module.exports = __webpack_public_path__ + "img/reback.04cb6eef.svg";